<template>
  <div v-if="channelInfo" class="live flex flex-col">
    <VueAliplayer
        v-if="channelInfo.playUrl"
        class="video"
        :preload="true"
        :autoplay="true"
        :playsinline="false"
        :source="channelInfo.playUrl"
        ref="video"
        :is-live="true"
        :skinLayout="skinLayout"
        :height="videoHeight"
        :video-height="videoHeight"
        :cover="channelInfo.coverUrl"
        @play="onStartPlay"
        style="width: 100%;flex:none"
    />
    <div v-else>
      <img :src="channelInfo.coverUrl" alt="" style="width: 100%;"/>
    </div>
    <div class="comment-header">
      <span class="onlookers">围观</span>
      <!-- <div class="comment-subheader">
        <a @click="jumpTo" class="link S4 C9"
          >点击屏幕右侧福袋，添加直播小助手，领取策略会福利。
        </a>
      </div> -->
    </div>
    <div class="comment-list" ref="commentList">
      <LiveCommentList
          @touchmove.stop
          v-if="commentsInfo"
          videoType="live"
          :commentsInfo="commentsInfo"
          :showInput="true"
          :hasPermission="true"
          @onReplyEvent="onReplyEvent"
          :commentCount="false"
      />
    </div>
    <!-- <img class="fixed" src="./images/fuli.png" alt="" @click="jumpTo" /> -->
  </div>
</template>
<script>
import VueAliplayer from '@/views/test/VueAliplayer'
import util from '@/util/util'
import LiveCommentList from '@/views/comment/components/LiveCommentList'
import api from '@/api/api'
import {isIOS} from '@/api/appInfo'
import {requestappInfo} from '@/api/appInfo'
import {mapActions} from 'vuex'
import {getClientInfo, getParam, Log} from '@em/ym'
import config from '@/api/config'
import ym from '../../assets/js/ym'

export default {
  components: {
    VueAliplayer,
    LiveCommentList
  },
  data() {
    return {
      commentsInfo: null,
      channelInfo: null,
      playUrl: null,
      channelId:
          process.env.VUE_APP_ENV === 'production'
              ? '10003'
              : process.env.VUE_APP_ENV === 'development'
                  ? '10005'
                  : '10004',
      identifier: new Date().getTime(),
      progressToSeek: 0,
      skinLayout: [
        {
          name: 'bigPlayButton',
          align: 'cc'
        },
        {
          name: 'H5Loading',
          align: 'cc'
        },
        {
          name: 'errorDisplay',
          align: 'tlabs',
          x: 0,
          y: 0
        },
        {
          name: 'controlBar',
          align: 'blabs',
          x: 0,
          y: 0,
          children: [
            {
              name: 'progress',
              align: 'blabs',
              x: 0,
              y: 44
            },
            {
              name: 'playButton',
              align: 'tl',
              x: 15,
              y: 12
            },
            {
              name: 'timeDisplay',
              align: 'tl',
              x: 10,
              y: 7
            },
            {
              name: 'fullScreenButton',
              align: 'tr',
              x: 10,
              y: 12
            }
          ]
        }
      ],
      videoHeight: util.getVideoHeight() + 'px',
      timer: null
    }
  },

  computed: {},

  watch: {},
  mounted() {
    Log.pageView({
      targetView: 'yktApp:Activity:LiveBroadcast20220211'
    })

    this.channelId = getParam('channelId') || this.channelId
    console.log('this.channelId:', this.channelId)
    requestappInfo()
    this.getChannel()

    this.$onResume(() => {
      requestappInfo()
      getClientInfo(() => {
        this.getChannel()
      })
    })

    this.timer = setInterval(() => {
      this.getChannel()
    }, 30000)

    this.$once('hook:beforeDestroy', () => {
      this.delInterval()
    })
    ym.showMenuItems({
      menuItems: [
        {
          callback: () => {
            ym.showSharePop({
              title: '直播',
              content: '有看投',
              url: `${config.h5Url}/live-broadcast/?appId=31&wxAppId=wx738f0151ab06d507&channelId=${this.channelId}`
            })
          },
          icon:
              'https://appstatic.emoney.cn/images/20210419/9365ccedef860827d27e3ac32c638071.png'
        }
      ]
    })
  },

  methods: {
    ...mapActions('appInfo', ['requestappInfo']),
    onReplyEvent(item) {
      this.$emit('onReplyEvent', item)
    },
    getChannel() {
      api.channel
          .getChannel({
            id: this.channelId
          })
          .then(res => {
            if (res.result.code === 0 && res.detail) {
              this.commentsInfo = {topicId: res.detail.channelInfo.topicId}
              this.channelInfo = res.detail.channelInfo
              if (this.channelInfo.status === 1) {
                this.channelInfo.playUrl
              } else if (this.channelInfo.status === 3) {
                this.channelInfo.coverUrl = require('./images/end.png')
                this.channelInfo.playUrl = ''
              }
              if (this.channelInfo.status !== 1) {
                this.delInterval()
              }
            }
          })
    },
    onStartPlay() {
      this.$emit('onStartPlay')
    },
    jumpTo() {
      if (isIOS()) {
        const url = `${
            process.env.VUE_APP_ENV === 'staging'
                ? 'https://yktpre.emoney.cn/yktstatic'
                : 'https://yktstatic.emoney.cn'
        }/ykthtml/yktapp/?route=transit-page`
        location.href = `ycstock://browser?thirdapp=true&url=${encodeURIComponent(
            url
        )}`
      } else {
        api.channel.getWechatSchemaLink().then(res => {
          const {detail, result} = res
          if (result && result.code === 0) {
            location.href = detail
          }
        })
      }
    },
    updateScroll(isRefresh) {
      var scrollBottom =
          this.$refs.commentList.scrollHeight -
          this.$refs.commentList.clientHeight -
          this.$refs.commentList.scrollTop
      if (!isRefresh) {
        this.scrollToBottom()
      } else {
        if (scrollBottom <= 30) {
          this.scrollToBottom()
        }
      }
    },
    scrollToBottom() {
      setTimeout(() => {
        this.$refs.commentList.scrollTop = 1000000
      }, 50)
    },
    delInterval() {
      if (this.channelInfo.status == 2) {
        this.$refs.video.reloadPlayer()
      }
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.live {
  height: 100vh;
  flex-direction: column;
}

.comment-header {
  width: 100%;
  position: relative;
  height: 82px;
}

.onlookers {
  font-size: 30px;
  position: relative;
  display: inline-block;
  color: #046bcc;
  height: 80px;
  margin-left: 15px;
  line-height: 80px;

  &::after {
    height: 6px;
    width: 40px;
    content: '';
    position: absolute;
    left: 8px;
    bottom: 5px;
    background-color: #046bcc;
  }
}

.link {
  text-decoration: none;
}

.comment-list {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #efeff4;
  padding-bottom: 130px;
}

.comment-subheader {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  bottom: -92px;
  left: 0;
  padding: 12px 15px;
  margin-top: 6px;
  margin-bottom: 6px;
  background-color: #f5e5c4;
  z-index: 99;
}

.fixed {
  position: fixed;
  top: 50%;
  right: 0;
  width: 150px;
}
</style>
